import { render } from "./Organization.vue?vue&type=template&id=1acfec66"
const script = {}
script.render = render

export default script